module.exports = __webpack_public_path__ + "img/841-face3e.png";